import MySavedCartsPage from './MySavedCartsPage';

export default MySavedCartsPage;
